export const base_filter = [
	{ key: "search", label: "Buscar", type: "text", value: "", visible: true, placeholder: "Nombre" },
	{ key: "type", label: "Tipo de OA", type: "select", multiple: true, value: "", visible: true, placeholder: "Selecciona un tipo", options: [] },
];

export const base_table = { page: 1, per_page: 100, order_by: "name", order_dir: "asc" };

export const base_object = { id: "", name: "", application_order_type_id: "", description: "", estate_parent_id: "", estate_id: "" };
